<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="1100">
      <c-card class="white" title="예약 정보 변경">
        <v-form lazy-validation>
          <v-row>
            <v-col cols="12" sm="6" md="2">
              <span class="font-weight-black">예약자</span>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <span>{{getReservationData('customerName')}}</span>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <span class="font-weight-black">예약 날짜</span>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <span>{{getReservationData('created')}}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">연락처</span>
            </v-col>
            <v-col cols="12" md="10" sm="6">
              <span>{{getReservationData('customerNo')}}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black align-self-center">비상 연락처</span>
            </v-col>
            <v-col cols="12" md="10" sm="6">
              <v-row class="pa-0">
                <v-col cols="3" class="pr-0 pl-0">
                  <v-select
                    tabindex="6"
                    v-model="selectedFamily"
                    :items="familyList"
                    label="관계"
                    item-text="familyRelation"
                    item-value="idx"
                    @change="onChangedFamily"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    tabindex="7"
                    v-model="otherFamilyRelation"
                    label="관계"
                    prepend-inner-icon="cell"
                    :disabled="familyFlag"
                    outlined
                    dense
                    maxlength="32"
                  ></v-text-field>
                </v-col>
                <v-col cols="5" class="pr-0 pl-0">
                  <v-text-field
                    tabindex="8"
                    v-model="otherFamilyNo"
                    @change="checkHypen"
                    label="번호를 입력해주세요."
                    prepend-inner-icon="cell"
                    :disabled="familyFlag"
                    maxLength="13"
                    outlined
                    class="pr-5"
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider>

          <v-row>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">출발 시간</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <span>{{getReservationData('startTime')}}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">서비스 종료 시간</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <span>{{getReservationData('endTime')}}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">차량 이용 대수</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <span>{{getReservationData('vehicleCnt')}}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">차종</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <span>{{ getReservationData('vehicleType') }}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">소요 시간</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <span>{{getReservationData('driveTime')}}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">도움서비스 시간</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <span>{{getReservationData('serviceTime')}}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">예약 인원</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <span>{{getReservationData('customerCnt')}}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">요청 사항</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                outlined
                dense
                v-model="customerComment"
                maxlength="30"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">용도</span>
            </v-col>
            <v-col cols="12" md="10" sm="6">
              <v-row>
                <v-col cols="3" class="pt-0 pb-0 mt-0 mb-0">
                  <v-select
                    v-model="selectedUse"
                    :items="useList"
                    item-text="label"
                    item-value="value"
                    label="용도"
                    outlined
                    dense
                    maxlength="256"
                  ></v-select>
                </v-col>
                <v-col cols="4" class="pt-0 pb-0 mt-0 mb-0">
                  <v-text-field
                    v-if="selectedUse === -1"
                    v-model="otherUse"
                    label="직접 입력"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="5" class="pt-0 pb-0 mt-0 mb-0"></v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">수하물</span>
            </v-col>
            <v-col cols="12" md="10" sm="6">
              <v-row align="center">
                <v-checkbox
                  v-for="luggage in luggageList"
                  v-model="selectedLuggage"
                  :label="luggage.label"
                  :value="luggage.value"
                  @change="onSelectLuggage(luggage.value)"
                  class="mr-3" dense>
                </v-checkbox>
                <v-text-field :disabled="selectedLuggage.indexOf(-1) === -1"
                              v-model="otherLuggage"
                              label="기타 수하물 입력"
                              maxlength="128"/>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="12" md="2" sm="6" class="align-self-center">
              <span class="font-weight-black">구간</span>
            </v-col>
            <v-col cols="12" md="10" sm="6">
              <v-menu
                v-model="suburban.showSuburbanList"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="500px"
                max-height="300px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    prepend-inner-icon="search"
                    :value="getSelectedSuburbanText(suburban.selectedSuburban ? suburban.selectedSuburban.configName : '', 1)"
                    dense readonly
                    @click="suburban.showSuburbanList = true"
                  />
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in getSuburban"
                    :key="index"
                    @click="suburban.selectedSuburban = item"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ getSelectedSuburbanText(item.configName, 0) }}</v-list-item-title>
                      <v-list-item-subtitle>{{ getSelectedSuburbanText(item.configName, 1) }}({{getSelectedSuburbanText(item.configName, 2)}})</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
          <v-row v-for="(item, index) in reservationRouteList" :key="index" >
              <v-col cols="3" md="2" sm="6" class="align-self-center">
                <span v-if="index === 0 " class="font-weight-black">출발지</span>
                <span v-else class="font-weight-black">{{index === reservationRouteList.length-1 ? '도착지' : `경유지${index}`}}</span>
              </v-col>
              <v-col v-if="index === 0" cols="12" md="10" sm="6">
                <div class="pb-2">{{getReservationData('reservationRouteList', index)}}</div>
                <div>
                  <v-text-field
                    outlined
                    dense
                    label="출발지 추가정보"
                    v-model="item.comment"
                    maxlength="255"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col v-else cols="12" md="10" sm="6">
                <div class="pb-2">{{getReservationData('reservationRouteList', index)}}</div>
                <div>
                  <v-text-field
                    outlined
                    dense
                    :label="index === reservationRouteList.length-1 ? '도착지 추가정보' : `경유지${index} 추가정보`"
                    v-model="item.comment"
                    maxlength="255"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          <v-divider></v-divider>
        </v-form>
        <v-row justify="center">
          <c-btn class="mr-2 mt-3" color="blue" @click="updateReservationInfo" outlined>수정</c-btn>
          <c-btn class="mt-3" color="blue" outlined @click="openFlag = false">취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import {mask} from "vue-the-mask";

  export default {
    directives: { mask },
    props: {
      open: {
        type: Boolean,
        default: false
      },
      reservationData: {
        type: Array,
        default: []
      },

    },
    mounted() {

    },
    computed: {
      getSuburban() {
        return this.$store.state.config.suburban;
      },
      checkHypen() {
        if (this.otherFamilyNo) {
          this.otherFamilyNo = this.otherFamilyNo.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3").replace("--", "-");
        }
      }
    },
    watch: {
      open(value) {
        if (value && this.reservationData) {
          this.getReservationInfo(this.reservationData[0].reservationId);
        }
        this.luggageList = this.$store.state.luggageList;
        this.openFlag = value;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
      selectedLuggage() {
        if (this.selectedLuggage.indexOf(-1) === -1) {
          this.otherLuggage = "";
        }
        if (this.selectedLuggage.length === 0) {
          this.selectedLuggage = ['없음'];
        }
      },
      reservationUpdateInfo() {
        this.onSetFamilyInfo();
        this.onSetOtherInfo();

        const reservationData = this.reservationUpdateInfo[0];

        this.customerCnt = reservationData.customerCnt;
        this.customerComment = reservationData.customerComment;
        this.selectedUse = reservationData.customerUsage;
        this.selectedLuggage = reservationData.luggage;
        this.reservationRouteList = reservationData.reservationRouteList;
        this.suburban.selectedSuburban = reservationData.suburban;

      },
    },
    data: () => ({
      reservationUpdateInfo:[],
      suburban: {
        suburbanText: '',
        selectedSuburban: null,
        showSuburbanList: false,
      },

      maskPeople: '##',

      openFlag: false,
      familyList: [{familyRelation: '직접 입력', familyNo: '', idx: 0}],
      familyFlag: true,

      selectedFamily: 0,
      selectedLuggage: ['없음'],

      customerInfo: {},

      otherFamilyNo: '',
      otherFamilyRelation: '',

      customerComment: '',

      useList: [
        {label: '출타/귀가', value: '출타/귀가'},
        {label: '출근/퇴근', value: '출근/퇴근'},
        {label: '병원', value: '병원'},
        {label: '보조', value: '보조'},
        {label: '배송', value: '배송'},
        {label: '직접 입력', value: -1}
      ],
      luggageList: [],

      useFlag: true,
      otherCustomerCnt: 5,
      selectedUse: '',
      otherUse: '',

      otherLuggage: '',

      reservationRouteList: [],
    }),
    methods: {
      async getReservationInfo(reservationId) {
        const res = await this.$api.getReservation(reservationId);
        this.reservationUpdateInfo =  res.data;
      },
      getSelectedSuburbanText(text, idx) {
        return text && (text.indexOf('|') > -1)? text.split('|')[idx]: '';
      },
      getReservationData(key, index) {
        if (this.reservationUpdateInfo && this.reservationUpdateInfo.length > 0) {
          let data = this.reservationUpdateInfo[0][key];
          if (key === 'created') {
            data = this.$func.dateTimeToString(data);
          } else if(key ==='reservationRouteList'){
            data = data[index].position;
          } else if (key === 'driveTime') {
            data = this.$func.msToTimeFormat(data);
          } else if (key === 'vehicleType') {
            let vehicleType = [];
            let types = data.split(',');
            for (const i in types) {
              let vehicle = types[i];
              if (vehicle === 'c_11seat') {
                vehicleType.push('11인승');
              }
              if (vehicle === 'c_15seat') {
                vehicleType.push('15인승');
              }
              if (vehicle === 'c_5seat') {
                vehicleType.push('승용차');
              }
              if (vehicle === 'c_9seat') {
                vehicleType.push('9인승');
              }
            }
            data = vehicleType.toString();
          }
          return data;
        } else {
          return '';
        }
      },
      async reqGetCustomerOfReservation() {
        try {
          if (!this.reservationUpdateInfo || !this.reservationUpdateInfo[0] || !this.reservationUpdateInfo[0].customerId) return;
          const res = await this.$api.getCustomer(this.reservationUpdateInfo[0].customerId.id);
          this.customerInfo = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetCustomerOfReservation'});
        }
      },
      onSetFamilyInfo() {
        this.reqGetCustomerOfReservation();

        setTimeout(() => {
          const customerInfo = this.customerInfo;
          const reservationData = this.reservationUpdateInfo[0];
          const familyList = [this.familyList[0]];

          // 예약자가 비회원인 경우
          if (!this.customerInfo) {
            this.familyFlag = true;
            this.selectedFamily = this.familyList[this.familyList.length - 1];
            this.otherFamilyNo = reservationData.familyNo;
            this.otherFamilyRelation = reservationData.familyRelation;
            return;
          }

          // familyContractList 파싱
          let familyContactList = customerInfo.familyContactList;
          try {
            if(familyContactList) {
              familyContactList = JSON.parse(familyContactList);

              familyContactList.forEach((contact, idx) => {
                const {relation, phone} = contact;
                familyList.push({familyRelation: relation, familyNo: phone, idx: idx+1});
              })

            }
          } catch (e) {
            console.error('fail to parse familyContactList')
          }

          this.familyList = familyList;

          // 회원 정보와 예약 정보를 비교
          // 회원 정보에 예약의 비상연락망과 일치하는 정보가 있나 확인
          let familySetting = familyList.find(item =>
            item.familyNo === reservationData.familyNo && item.familyRelation === reservationData.familyRelation
          );

          if (familySetting) {
            this.familyFlag = true;
            this.selectedFamily = familySetting;
            this.otherFamilyRelation = familySetting.familyRelation;
            this.otherFamilyNo = familySetting.familyNo;
          } else {
            this.familyFlag = false;
            this.selectedFamily = this.familyList[0];
            this.otherFamilyNo = reservationData.familyNo;
            this.otherFamilyRelation = reservationData.familyRelation;
          }
        }, 300);
      },
      onChangedFamily(idx) {
        if (idx === 0) {
          this.familyFlag = false;
          this.otherFamilyRelation = '';
          this.otherFamilyNo = '';
        } else {
          this.familyFlag = true;
          this.otherFamilyRelation = this.familyList[idx].familyRelation;
          this.otherFamilyNo = this.familyList[idx].familyNo;
        }
      },
      onSetOtherInfo() {
        setTimeout(() => {
          // 수하물
          let reservedLuggage = this.getReservationData('luggage').split(',');

          const showRadio = [];
          const showEtc = [];
          for (let item of reservedLuggage) {
            if(this.luggageList.map(item=>item.value).indexOf(item) > -1)
              showRadio.push(item);
            else
              showEtc.push(item);
          }
          if(showEtc.length > 0) showRadio.push(-1);

          this.selectedLuggage = showRadio;
          this.otherLuggage = showEtc.length > 0 ? showEtc.join() : '';


          // 용도
          let reseravtionUsage = this.reservationUpdateInfo[0].customerUsage;
          if (this.useList.map(item => item.value).indexOf(reseravtionUsage) === -1) {
            this.selectedUse = -1;
            this.otherUse = reseravtionUsage;
          }


        }, 300);
      },
      async updateReservationInfo() {
        const res = await this.$api.checkEnableReservation(this.reservationId);
        if (!res.data) {
          this.$store.commit('alert',
            {
              open: true, persistent: true, msg: "이용중 상태의 예약정보는 변경할 수 없습니다.",
              info: true
            });
            return;
        }
        
        // 수하물
        if(this.selectedLuggage.indexOf(-1) > -1) {
          let idx = this.selectedLuggage.indexOf(-1);
          this.selectedLuggage.splice(idx, 1, this.otherLuggage)
        } else {
          this.otherLuggage='';
        }
        this.luggage = this.selectedLuggage.join();

        let usages = this.selectedUse !== -1 ? this.selectedUse : this.otherUse;
        if(this.selectedUse !== -1) {
          usages = this.selectedUse;
          this.otherUse = '';
        } else {
          usages = this.otherUse;
        }

        const newResrvInfo = this.reservationUpdateInfo.map(item => {
          let newItem = {...item};
          
          newItem.familyNo = this.otherFamilyNo;
          newItem.familyRelation = this.otherFamilyRelation;
          newItem.customerCnt = (this.customerCnt !== -1) ? this.customerCnt : this.otherCustomerCnt;
          newItem.customerComment = this.customerComment;
          newItem.customerUsage = usages;
          newItem.luggage = this.luggage;
          newItem.reservationRouteList = this.reservationRouteList;
          newItem.suburban = this.suburban.selectedSuburban;
          newItem.suburban.configKey = "suburban";
          return newItem;
        });

        this.$emit('editReservationInfo', newResrvInfo);
        this.openFlag = false;
      },
      onSelectLuggage(value) {
        if (value === '없음') {
          this.selectedLuggage = ['없음'];
        } else {
          if (this.selectedLuggage.indexOf('없음') > -1) {
            let idx = this.selectedLuggage.indexOf('없음');
            this.selectedLuggage.splice(idx, 1);
          }
        }
      },
    }

  }
</script>
<style scoped>
</style>
